// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  videoLibrary: {
    noFolder: `Videos without folder`,
    status: {
      ready: `Ready`,
      processing: `Processing`,
      failed: `Failed`,
    },
    actions: {
      download: `Download`,
      edit: `Edit`,
      delete: `Delete`,
      save: `Save`,
      cancel: `Cancel`,
      moreOptions: `More options`,
      move: `Move to folder`,
    },
    selection: {
      selectAll: `Select all`,
      selectVideo: `Select {{title}}`,
      countInFolder: `{{selected}} of {{total}} selected in this folder`,
      countFiltered: `{{selected}} of {{total}} selected in this folder, with filters applied`,
      move: `Move to folder`,
      clear: `Clear selection`,
      footer_one: `{{count}} selected`,
      footer_other: `{{count}} selected`,
    },
    moveVideos: {
      title_one: `Move {{count}} video`,
      title_other: `Move {{count}} videos`,
      description: `The videos leave "{{source}}" for the chosen folder and stay linked to the lessons that already use them.`,
      destination: `Destination folder`,
      choose: `Choose the folder`,
      noDestination: `Create another folder to have a destination.`,
      confirm: `Move`,
      cancel: `Cancel`,
      close: `Close`,
      moving: `Moving {{done}} of {{total}}…`,
      resultTitle: `{{moved}} of {{total}} videos moved to "{{destination}}"`,
      failedTitle_one: `{{count}} video was not moved:`,
      failedTitle_other: `{{count}} videos were not moved:`,
      failedDefaultReason: `This video could not be moved.`,
      reasons: {
        notFound: `Video not found in your library.`,
      },
    },
    deleteVideo: {
      title: `You are about to permanently delete this video.`,
      content: `This action cannot be undone.\nThe video will be permanently removed from the platform.`,
      cancel: `Cancel`,
      confirm: `Delete`,
      deleting: `Deleting...`,
    },
    deleteFolder: {
      title: `You are about to delete this folder.`,
      content: `The videos in this folder will be moved to "Videos without folder".\nThis action cannot be undone.`,
      cancel: `Cancel`,
      confirm: `Delete`,
      deleting: `Deleting...`,
    },
    toasts: {
      inProgress: `Upload in progress. Don't close this screen.`,
      partialFailed: `Some videos failed to upload. Please try again.`,
      failed: `Upload failed. Please try again.`,
      success: `Uploads completed successfully!`,
      blockClose: `There are uploads in progress. Wait for them to finish before closing.`,
      folderCreated: `Folder created.`,
      folderRenamed: `Folder renamed.`,
      folderDeleted: `Folder deleted.`,
      videoRenamed: `Video renamed.`,
      videoDeleted: `Video deleted.`,
      videosMoved_one: `{{count}} video moved to "{{destination}}".`,
      videosMoved_other: `{{count}} videos moved to "{{destination}}".`,
    },
    empty: {
      noFolders: `No folders found`,
      noVideos: `No files in this folder`,
    },
    download: {
      title: `Your video is being downloaded`,
      content: `We're finishing the download for you.\nDon't close this page until the download finishes`,
    },
    errors: {
      load: `We couldn't load the videos. Please try again.`,
      createFolder: `Error creating the folder. Please try again.`,
      renameFolder: `We couldn't rename the folder. Please try again.`,
      deleteFolder: `We couldn't delete the folder. Please try again.`,
      renameVideo: `We couldn't rename the video. Please try again.`,
      deleteVideo: `We couldn't delete the video. Please try again.`,
      moveVideos: `Could not move the videos. Try again.`,
      upload: `Error uploading the video. Please try again.`,
      duplicateFile: `This video has already been added.`,
      maxFilesExceeded_one: `You can upload up to {{max}} videos at a time. {{count}} video was not added.`,
      maxFilesExceeded_other: `You can upload up to {{max}} videos at a time. {{count}} videos were not added.`,
      maxFileSizeExceeded_one: `{{count}} video exceeds the maximum size of {{max}} and was not added.`,
      maxFileSizeExceeded_other: `{{count}} videos exceed the maximum size of {{max}} and were not added.`,
      invalidFormat_one: `File {{names}} has an invalid format. Please upload only files in the following formats: MP4, MOV, AVI or MKV. Try again.`,
      invalidFormat_other: `Files {{names}} have an invalid format. Please upload only files in the following formats: MP4, MOV, AVI or MKV. Try again.`,
    },
  },
  productMembersArea: {
    lessonMaterials: {
      sectionTitle: `Extra materials`,
      empty: `No materials added to this lesson yet.`,
      download: `Download`,
      delete: `Delete`,
      confirmDeleteTitle: `Remove this material?`,
      confirmDeleteContent: `The material will be removed from the members area.`,
      confirmDeleteAction: `Remove material`,
      cancel: `Cancel`,
      deleteSuccess: `Material deleted successfully.`,
      retry: `Try again`,
      addTitle: `Add material`,
      titleLabel: `Title`,
      descriptionLabel: `Description (optional)`,
      chooseFile: `Choose file`,
      fileHelperFormats: `Accepted formats: {{formats}}.`,
      fileHelperMaxSize: `Maximum size: {{max}} per file.`,
      fileTypeWarning: `Format outside the accepted list: {{formats}}. The upload may be refused.`,
      limitsLoading: `Loading the upload limits…`,
      limitsUnavailable: `Could not load the upload limits. The file will be validated on upload.`,
      capacity: `This lesson has {{total}} of {{max}} materials. There is room for {{remaining}} more.`,
      capacityReached: `This lesson reached the limit of {{max}} materials. To add another, remove one of the current ones.`,
      capacityExceeded: `This lesson has {{total}} materials, above the limit of {{max}}. They all remain available to students, but to add a new one you need to remove at least {{toRemove}}.`,
      capacityQueueExceeded: `The queue goes over the limit of {{max}} materials per lesson: remove {{excess}} from the queue before saving.`,
      uploading: `Uploading… {{percent}}% · {{loaded}} of {{total}}`,
      cancelUpload: `Cancel upload`,
      uploadCanceled: `Upload canceled. No material was added.`,
      flushCanceled: `Upload canceled. The materials that did not go up stay in the list for you to try again.`,
      addButton: `Add`,
      createSuccess: `Material added successfully.`,
      errors: {
        load: `Failed to load the lesson materials.`,
        create: `Failed to add the material. Please try again.`,
        delete: `Failed to delete the material. Please try again.`,
        download: `Failed to download the material. Please try again.`,
        popupBlocked: `The browser blocked the new tab. Allow pop-ups for this site and try again.`,
        notFound: `Material not found.`,
        lessonNotFound: `Lesson not found.`,
        forbidden: `You don't have permission for this action.`,
        fileTooLarge: `File too large. Maximum size: {{max}} per file.`,
        invalidFileType: `Format not accepted. Upload a file in one of these formats: {{formats}}.`,
        uploadTimeout: `The upload took longer than allowed and was interrupted. No material was added. Try a faster connection or a smaller file.`,
        uploadNetwork: `The connection dropped during the upload. No material was added. Check your connection and try again.`,
        batchOverLimit: `No material was uploaded: the lesson accepts up to {{max}} materials and there is room for {{available}} more. Remove {{excess}} from the queue and save again.`,
        invalidFileKey: `Invalid file key.`,
        titleRequired: `Title is required.`,
      },
    },
  },
  subscriptionsDrawer: {
    canceledBy: {
      subscriber: `Canceled by the subscriber`,
      producer: `Canceled by the producer`,
      api: `Canceled by the integration (API)`,
      system: `Canceled by Cakto`,
    },
    cancellationReason: `Reason: {{reason}}`,
  },
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  languages: {
    pt: `Brazil`,
    en: `English`,
    es: `Spanish`,
    cn: `Chinese`,
  },
  pagination: {
    previousPage: `Previous page`,
    nextPage: `Next page`,
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  ratingSurvey: {
    logoAlt: `Cakto logo`,
    pageTitle: `We want to hear your opinion!`,
    pageSubtitle: `Your feedback helps us keep improving our products.`,
    satisfactionQuestion: `How satisfied are you with the product?`,
    commentLabel: `Can you tell us why you gave this rating?`,
    commentPlaceholder: `Type your answer here...`,
    charCount: `{{count}}/500 characters`,
    submit: `Submit feedback`,
    submitting: `Sending...`,
    errorGeneric: `Could not submit your review. Please try again.`,
    cactusLabels: {
      1: { line1: `Very`, line2: `Dissatisfied!` },
      2: { line1: `Dissatisfied`, line2: `` },
      3: { line1: `Neutral`, line2: `` },
      4: { line1: `Satisfied!`, line2: `` },
      5: { line1: `Very`, line2: `Satisfied!` },
    },
    validation: {
      ratingRequired: `Rating is required`,
      ratingMin: `Select at least 1 cactus`,
      ratingMax: `Maximum 5 cacti`,
      commentRequired: `Comment is required`,
      commentMin: `Please tell us more about your experience (minimum 10 characters)`,
    },
    errorState: {
      expired: {
        title: `Your survey link has expired`,
        messageBold: `The survey is available for up to 7 days after your purchase.`,
        messageNormal: `This window helps ensure the feedback reflects your most recent experience. You can participate again on a future purchase if you like.`,
      },
      already_used: {
        title: `Review already sent`,
        message: `You have already submitted your review for this product. Thank you for your feedback!`,
      },
      error: {
        title: `Invalid link`,
        message: `This link is not valid. Check that you copied the full link from the email.`,
      },
      goToPlatform: `Go to the platform`,
    },
  },
  subscriberFlow: {
    common: {
      logoAlt: `Cakto logo`,
      loadError: {
        title: `Something went wrong`,
        description: `We couldn't load your information. This doesn't mean you have no subscriptions.`,
        retry: `Try again`,
      },
      backToSubscriptions: `My subscriptions`,
      signOut: `Sign out`,
      price: `{{amount}}/{{interval}}`,
      interval: {
        monthly: `month`,
        yearly: `year`,
        weekly: `week`,
        everyNDays: `{{days}} days`,
      },
      paymentMethod: {
        card: `Credit card`,
        cardWithDigits: `Card •••• {{lastDigits}}`,
        automaticPix: `Automatic Pix`,
        pix: `Pix`,
        boleto: `Boleto`,
      },
    },
    home: {
      title: `My subscriptions`,
      description: `Sign in with the email or phone number you used at checkout. No password and no new account — we send you a verification code.`,
      identifierLabel: `Email or phone number used at checkout`,
      identifierPlaceholder: `Enter your email or phone number (with area code)`,
      sendCode: `Get access code`,
      comingSoon: `Coming Soon`,
      google: {
        signIn: `Sign in with Google`,
        or: `or`,
        signingIn: `Signing in with Google…`,
        notice: {
          noAccount: `We couldn't find an account or subscription with your Google email. Enter the email or phone number used at checkout.`,
          useCode: `For this email, confirm with the code: enter the email below.`,
          expired: `Your Google sign-in expired. Try again.`,
          failed: `We couldn't sign you in with Google. Try again.`,
        },
      },
      link: {
        signingIn: `Opening your subscription…`,
        notice: {
          invalid: `This access link has expired or is no longer valid. Sign in with the email you used at checkout to continue.`,
          failed: `We couldn't open your subscription from the link right now. Sign in with the email you used at checkout to continue.`,
          sessionEnded: `Your session from the link has ended. Open the link in the notice again or sign in with the email you used at checkout.`,
        },
      },
      validation: {
        identifierRequired: `Enter the email or phone number used at checkout`,
        identifierInvalid: `Enter a valid email or a phone number with area code`,
      },
      toast: {
        codeResent: `Code resent.`,
        codeResentEmail: `Code resent. Check your email.`,
        codeResentWhatsapp: `Code resent. Check your WhatsApp.`,
      },
      errors: {
        sendCode: `We could not send the code. Please try again in a moment.`,
        tooManyAttempts: `Too many attempts in a short time. Wait a minute and try again.`,
        phoneLoginUnavailable: `Phone sign-in is unavailable right now. Use the email from your purchase.`,
      },
    },
    verifyCode: {
      description: `We sent a 6-digit code to {{identifier}}.`,
      descriptionEmail: `We sent a 6-digit code to {{identifier}} by email.`,
      descriptionWhatsapp: `We sent a 6-digit code to {{identifier}} by WhatsApp.`,
      codeLabel: `Verification code`,
      codePlaceholder: `000000`,
      submit: `Sign in`,
      changeIdentifier: `Change email/phone number`,
      resendCode: `Resend code`,
      resendCodeIn: `Resend code in {{seconds}}s`,
      resendCodeLocked: `Resend code in {{minutes}} min`,
      lockOver: `The wait is over. Request a new code to sign in.`,
      validation: {
        codeInvalid: `Enter the 6-digit code we sent you.`,
      },
      errors: {
        confirmCode: `We could not confirm the code. Please try again.`,
        wrongCode: `Invalid or expired code. Check the code or request a new one.`,
        locked: `Too many attempts with a wrong code. For your security, wait {{minutes}} min and request a new code.`,
      },
    },
    header: {
      loggedInAs: `Session for`,
      linkAccess: `Signed in from the notice link`,
      signInWithEmail: `Sign in with email`,
    },
    subscriptionsPage: {
      title: `My subscriptions`,
      description: `Manage payment and follow your active subscriptions. Session for {{identifier}} — no new account needed.`,
      descriptionLink: `You came in from the notice link and only see this subscription. To see the others, sign in with the email you used at checkout.`,
      status: {
        active: `Active`,
        inactive: `Inactive`,
        paymentPending: `Payment pending`,
        chargeProcessing: `Processing charge`,
        canceled: `Canceled`,
        expired: `Expired`,
        paused: `Paused`,
        trial: `Trial`,
        late: `Overdue`,
      },
      caption: {
        active: `{{price}} · {{method}} · next charge on {{nextChargeAt}}`,
        canceled: `{{price}} · {{method}} · canceled on {{canceledAt}} · upcoming charges stopped`,
        canceledWithoutDate: `{{price}} · {{method}} · canceled · upcoming charges stopped`,
        paymentPending: `{{price}} · payment not identified on {{failedAt}}`,
        paymentPendingWithoutDate: `{{price}} · payment not identified`,
      },
      pendingCallout: `Your charge was not approved. Automatic retries will be made — update your payment method by the last attempt ({{lastRetryAt}}) to avoid cancellation for non-payment.`,
      pendingCalloutWithoutDate: `Your charge was not approved. Automatic retries will be made — update your payment method before the last attempt to avoid cancellation for non-payment.`,
      pendingCalloutWithoutRetry: `Your charge was not approved, and no further automatic retries will be made.`,
      pendingCalloutPixRenewalExpired: `The renewal Pix expired and can no longer be paid. Choose how to pay to keep your subscription.`,
      resolvedByAutomaticPixCallout: `Automatic Pix authorized. The new charge is being processed — once approved, the non-payment is resolved and the status goes back to "Active".`,
      actions: {
        resolveNow: `Resolve now`,
        changePaymentMethod: `Change payment method`,
        reactivate: `Subscribe again`,
        viewHistory: `View history`,
        cancelSubscription: `Cancel subscription`,
        cancelNeedsEmail: `To cancel, sign in with the email you used at checkout`,
      },
      empty: {
        title: `You have no subscriptions yet`,
        description: `Once you subscribe to a product on Cakto, it shows up here — active or closed — with its status, amount and next charge date.`,
      },
      reactivateHint: `This creates a new subscription at the price and terms the offer has today. The old subscription stays closed.`,
      support: `Need help? Contact the producer at the support email provided at checkout.`,
      toast: {
        subscriptionCanceled: `Subscription canceled. Upcoming charges stop now.`,
        cancelFailed: `We couldn't cancel the subscription. Try again or contact support.`,
      },
    },
    cancelDialog: {
      title: `Cancel subscription`,
      description: `The {{productName}} subscription will be canceled. Upcoming charges stop now.`,
      irreversible: `This action can't be undone. To regain access later, you'll need to subscribe again, at the current price and terms.`,
      inputLabel: `Type {{phrase}} to confirm`,
      inputHelper: `Required confirmation to avoid canceling by mistake.`,
      keep: `Keep subscription`,
      confirm: `Confirm cancellation`,
      confirmationPhrase: `CANCEL SUBSCRIPTION`,
      reasonLabel: `Why are you canceling? (optional)`,
      reasons: {
        preferNotToSay: `Prefer not to say`,
        tooExpensive: `It got too expensive`,
        notUsing: `I'm not using it`,
        notAsExpected: `It wasn't what I expected`,
        accessProblem: `Access problem`,
        other: `Other reason`,
      },
      errors: {
        alreadyCanceled: `This subscription is already canceled.`,
        notCancelable: `This subscription can't be canceled here right now. Contact the producer at the support email provided at checkout.`,
        notLinked: `We couldn't find this subscription to cancel it. Contact the producer at the support email provided at checkout.`,
        cancelDisabled: `Canceling through the portal is unavailable right now. Try again later.`,
        cancelLateDisabled: `With a pending payment, canceling here is unavailable right now. Resolve the payment or try again later.`,
        invalidReason: `We didn't recognize the selected reason. Choose another one, or "Prefer not to say", and try again.`,
        emailScopeRequired: `To cancel, sign in with the email used at checkout.`,
        unavailable: `We couldn't cancel right now, and the subscription hasn't changed. Try again in a few minutes.`,
        unconfirmed: `We couldn't confirm the cancellation. Check your subscription list before trying again.`,
        tooManyAttempts: `Too many cancellation attempts. Wait a while and try again later.`,
      },
    },
    paymentPage: {
      title: `Update payment method`,
      contextPending: `{{productName}} · {{price}} · payment pending since {{failedAt}}`,
      contextPendingWithoutDate: `{{productName}} · {{price}} · payment pending`,
      contextActive: `{{productName}} · {{price}} · up to date`,
      callouts: {
        recoveryEmail: `You arrived from the recovery email — this is the pending subscription it mentioned.`,
        renewalReminder: `You arrived from the renewal reminder. Here you can check the payment method for the next charge and change it before the renewal.`,
      },
      notFound: {
        title: `Subscription not found`,
        description: `We couldn't find it among yours. If you came from an email, sign in with the email or phone number used for that purchase.`,
        switchAccount: `Sign in with another email or phone`,
      },
      errors: {
        subscriptionNotLinked: `This subscription's payment can't be changed here. Contact the producer at the support email provided at checkout.`,
        subscriptionEnded: `This subscription has ended. To continue, subscribe again.`,
        pixPaymentPending: `You already have a Pix generated for this charge. Pay that Pix or wait for it to expire to use another payment method.`,
        paymentMethodNotEnabled: `This payment method is not available for this subscription. Choose another one.`,
      },
      methods: {
        creditCard: `Credit card`,
        automaticPix: `Automatic Pix`,
        pix: `Pix`,
      },
      card: {
        holderNameLabel: `Cardholder name`,
        holderNamePlaceholder: `As printed on the card`,
        numberLabel: `Card number`,
        numberPlaceholder: `0000 0000 0000 0000`,
        expirationLabel: `Expiration`,
        expirationPlaceholder: `MM/YY`,
        cvvLabel: `CVV`,
        cvvPlaceholder: `000`,
        submitPending: `Save and run a new charge`,
        submitActive: `Save new card`,
        footnote: `The pending charge is processed immediately on the new card. Your previous history is kept.`,
        retry: `Try again`,
        errors: {
          infrastructure: `We couldn't process the charge right now. Please try again in a few minutes.`,
          cardNotProcessed: `We couldn't process this card. Check the details or use another card.`,
          issuerTimed: `The card issuer declined the charge for now, for example due to limit or insufficient funds. Use another card or try again later.`,
          issuer: `The charge was declined by the card issuer. Use another card.`,
          notApproved: `The charge was not approved. Use another card.`,
          chargeInProgress: `We couldn't save the card right now. A charge for this subscription may already be in progress: check the subscription before trying again.`,
          unconfirmed: `We couldn't confirm the card change or the charge. Check the subscription in a few minutes before trying again.`,
          tooManyAttempts: `Too many attempts. Please wait a moment before trying again.`,
          emailScopeRequired: `To change the subscription, sign in with the email used for the purchase.`,
          invalidCard: `Check the card details.`,
          generic: `We couldn't save the card.`,
        },
        validation: {
          holderNameRequired: `Enter the cardholder name as printed on the card.`,
          numberInvalid: `Enter the 16 digits of the card.`,
          expirationFormat: `Use the MM/YY format.`,
          expirationMonth: `Invalid month. Use 01 to 12.`,
          expirationExpired: `Expired card. Use a card with a future expiration date.`,
          cvvInvalid: `The CVV has 3 digits. Check the back of the card.`,
        },
      },
      automaticPix: {
        explanation: `Automatic Pix debits the subscription amount straight from your account every cycle, with nothing for you to do. You authorize it once in your bank app.`,
        start: `Generate authorization in my bank`,
        footnote: `Your previous charge history is kept after the migration.`,
        waitingTitle: `Waiting for your bank to confirm`,
        waitingDescription: `Open your bank app, scan the code and authorize the Automatic Pix for {{productName}} ({{price}}).`,
        waitingPolling: `Checking every 5 seconds…`,
        waitingBack: `Back`,
        pollingExhausted: `We haven't received confirmation from your bank. If you already authorized it, wait a few minutes and reload the page.`,
        generatingQr: `Generating code…`,
        pendingWithoutQr: `There is already an authorization waiting for your bank.`,
        applyingTitle: `Approved by your bank, applying the change`,
        applyingDescription: `Your bank authorized the Automatic Pix for {{productName}}. We are switching your subscription payment method, which takes a few moments.`,
        applyingExhausted: `Your bank approved it. The change is still being applied; check back in a few minutes.`,
        copyCode: `Copy Pix code`,
        codeCopied: `Pix code copied.`,
        copyFailed: `We couldn't copy the code.`,
        unavailable: {
          disabled: `Automatic Pix is unavailable right now. Use a credit card.`,
          subscription: `Automatic Pix isn't available for this subscription. Use a credit card.`,
          alreadyActive: `This subscription is already on Automatic Pix.`,
          notDelinquent: `Automatic Pix is authorized together with an open charge, and this subscription is up to date.`,
        },
      },
      noMethods: `This subscription cannot be paid here. Contact the producer at the support email provided with your purchase.`,
      pix: {
        generating: `Generating the Pix…`,
        title: `Pay with Pix`,
        description: `Open your bank app and pay {{amount}} for {{productName}} using the QR code or the copy-and-paste code.`,
        expiresAt: `Valid until {{expiresAt}}`,
        copyCode: `Copy Pix code`,
        codeCopied: `Pix code copied.`,
        copyFailed: `Could not copy the code.`,
        waitingPolling: `Waiting for payment. Checking every 5 seconds…`,
        pollingExhausted: `We have not received the payment confirmation yet.`,
        checkAgain: `I already paid, check again`,
        expired: `This Pix expired and can no longer be paid. Generate a new one to pay.`,
        canceled: `This Pix was canceled and can no longer be paid. Generate a new one to pay.`,
        generateNew: `Generate new Pix`,
        retry: `Try again`,
        footnote: `Your subscription stays on Pix: upcoming renewals will also arrive as a QR code.`,
        errors: {
          notEnabled: `Pix is not available for this subscription. Choose another payment method.`,
          notDelinquent: `There is no open charge on this subscription: it is already up to date.`,
          chargeInProgress: `A charge for this subscription is already in progress. Check the subscription before generating a Pix.`,
          unavailable: `We could not generate the Pix right now. Try again in a few minutes.`,
          generic: `Could not generate the Pix.`,
        },
      },
      toast: {
        cardUpdated: `Payment method updated.`,
        chargeProcessing: `The charge on the new card is being processed. The subscription will update as soon as the bank confirms.`,
        automaticPixAuthorized: `Automatic Pix authorized.`,
        automaticPixFailed: `We couldn't create the authorization. Please try again.`,
        automaticPixRejected: `Your bank didn't authorize Automatic Pix. Try again or use a card.`,
      },
    },
    historyPage: {
      title: `Payment history`,
      subtitle: `{{productName}} · {{price}}`,
      chargeStatus: {
        paid: `Approved`,
        refused: `Declined`,
        retrying: `Retrying`,
        waitingPayment: `Awaiting payment`,
        scheduled: `Scheduled`,
        refunded: `Refunded`,
        chargedback: `Chargeback`,
        canceled: `Canceled`,
        processing: `Processing`,
        authorized: `Authorized`,
        refundRequested: `Refund requested`,
        inSettlement: `Refund in progress`,
        acquirerError: `Refund not completed`,
        blocked: `Blocked`,
        inProtest: `In dispute`,
        partiallyPaid: `Partially paid`,
        prechargeback: `Dispute in review`,
        med: `Under review (MED)`,
      },
      detail: {
        firstCharge: `1st charge`,
        coupon: `coupon {{code}}`,
        retry: `retry {{attempt}}`,
        settledAt: `settled on {{paidAt}}`,
      },
      footnote: `Every attempt is recorded with the decline reason when available — nothing is left out.`,
      empty: `No charge recorded for this subscription yet.`,
    },
    successPage: {
      titleCard: `Non-payment resolved`,
      titleAutomaticPix: `Automatic Pix authorized`,
      titlePix: `Payment confirmed`,
      bodyCard: `The system ran a new charge for {{productName}} on the new card and it was approved. Your access is secured and the next charge will be on {{nextChargeAt}}.`,
      bodyAutomaticPix: `We received your bank's authorization. The system is running the new charge for {{productName}} — there is nothing else for you to do.`,
      bodyPix: `We received the Pix for {{productName}}. Your access is secured and the next charge will be on {{nextChargeAt}}.`,
      statusLabel: `Subscription status:`,
      back: `Back to my subscriptions`,
      footnote: `The non-payment was resolved: the retry schedule was stopped, the next charge was recalculated, the confirmation was sent by email and WhatsApp and the webhook was fired.`,
    },
  },
  refundFlow: {
    common: {
      logoAlt: `Cakto logo`,
      back: `Back`,
      of: `of`,
    },
    headerPurchase: {
      loggedInAs: `You are signed in as`,
      signOut: `Sign out`,
    },
    purchasesPage: {
      title: `My purchases`,
    },
    home: {
      title: `Request refund`,
      descriptionLine1: `You can request a refund within 7 days after purchase.`,
      descriptionLine2: `When requesting a refund, your purchase will be canceled and you will no longer have access to the product.`,
      identifierLabel: `Email or phone used in purchase`,
      identifierPlaceholder: `Enter your email or phone (with area code)`,
      findPurchase: `Find your purchase`,
      google: {
        signIn: `Sign in with Google`,
        or: `or`,
        signingIn: `Signing in with Google…`,
        notice: {
          noAccount: `We couldn't find an account or purchase with your Google email. Enter the email or phone used in the purchase.`,
          useCode: `For this email, confirm with the code: enter the email below.`,
          expired: `Your Google sign-in expired. Try again.`,
          failed: `We couldn't sign you in with Google. Try again.`,
        },
      },
      validation: {
        identifierRequired: `Enter the email or phone used in the purchase`,
        identifierInvalid: `Enter a valid email or a phone with area code`,
      },
      errors: {
        sendCode: `An error occurred while sending the code. Please try again later.`,
      },
    },
    verifyEmail: {
      exit: `Exit`,
      title: `Verify your email`,
      titleWhatsapp: `Verify your WhatsApp`,
      description: `If the email {{email}} is linked to a purchase, you will receive a verification code. Enter it below to continue.`,
      descriptionWhatsapp: `If the number {{phone}} is linked to a purchase, you will receive a verification code on WhatsApp. Enter it below to continue.`,
      resendCode: `Resend code`,
      continue: `Confirm code`,
      errors: {
        invalidOrExpiredToken: `Invalid or expired token. Please start the verification process again.`,
      },
    },
    purchase: {
      pageHeading: `Request a refund`,
      pageSubtitle: `Review your purchase details and select a reason. Required fields must be completed to continue.`,
      loadingDetails: `Loading purchase details…`,
      loadError: `We couldn’t load this purchase. Check your connection and try again.`,
      retry: `Try again`,
      orderNotFound: `We couldn’t find this purchase in your list or you don’t have permission to view it.`,
      orderNotFoundCta: `View my purchases`,
      backNavAria: `Back to purchase list`,
      backToRefundRequest: `Request refund`,
      productDetailsTitle: `Product details`,
      refundReasonTitle: `Refund reason`,
      selectReasonRequired: `Select the refund reason (required)*`,
      otherReason: `Other reason`,
      explainLabel: `Explain in your own words`,
      explainPlaceholder: `Tell the seller in more detail why you are requesting a refund`,
      requestRefundButton: `Request refund`,
      installments: `{{installments}}x of {{amount}}`,
      fields: {
        productName: `Product name`,
        amount: `Amount`,
        purchaseDate: `Purchase date`,
        refundDeadline: `Refund request deadline`,
        paymentMethod: `Payment method`,
        supportEmail: `Seller support email`,
        producerName: `Seller name`,
      },
      paymentMethods: {
        pix: `Pix`,
        creditCard: `Card`,
        ticket: `Boleto`,
        billet: `Boleto`,
        oxxo: `OXXO`,
        spei: `SPEI`,
        pixAuto: `Automatic Pix`,
        boleto: `Boleto`,
        debitCard: `Debit card`,
        pagaleveInstallments: `Pix in {{installments}} interest-free installments`,
        pagaleveUpfront: `Pix (paid in full)`,
        picpay: `PicPay`,
        googlepay: `Google Pay`,
        applepay: `Apple Pay`,
        paypal: `PayPal`,
        nubank: `Nubank`,
        mercadopago: `Mercado Pago`,
        pse: `PSE`,
        nequi: `Nequi`,
        safetypay: `SafetyPay`,
        unknown: `Unknown`,
      },
      refundReasons: {
        optionAccessIssue: `I still couldn't access the product, but I would like to`,
        optionNeedMoney: `I need the money for other things`,
        optionFilesNotOpening: `I got access, but pages or files do not open`,
        optionNoSupportResponse: `The seller does not respond to my support requests`,
        optionLowQuality: `The product quality did not meet my expectations`,
        optionIncompleteProduct: `The product is incomplete`,
        optionDuplicatePurchase: `Duplicate purchase`,
      },
      bankInfo: {
        title: `Bank details for the refund`,
        descriptionRequired: `This payment was made in cash, so we need the account where you want your money back. We cannot complete the refund without it.`,
        descriptionOptional: `If you want the refund sent to a specific account, enter the details below. You can also leave them blank.`,
        fields: {
          clabe: `CLABE`,
          clabeHelper: `The 18 digits of your CLABE account`,
          bank_account_holder_name: `Account holder name`,
          bank_account_holder_document: `Account holder document (CURP or RFC)`,
          bank_name: `Bank`,
          bank_branch: `Branch`,
          bank_account: `Account`,
          account_type: `Account type`,
        },
        validation: {
          clabe: `Invalid CLABE. Check the 18 digits.`,
          maxLength: `Value is longer than allowed`,
        },
      },
      validation: {
        required: `Required field`,
      },
      errors: {
        requestRefund: `There was an error while trying to process the refund. Please contact the seller directly.`,
      },
    },
    successModal: {
      title: `Refund confirmed`,
      description: `We received your request and it is already being processed.`,
      deadlineTitle: `You will be refunded within 24 hours`,
      deadlineDescription: `The amount goes back automatically — no seller approval needed.`,
      deadlineDescriptionWithAmount: `The {{amount}} goes back automatically — no seller approval needed.`,
      stepEmail: `We sent the confirmation to your email.`,
      stepMethod: `The full amount returns to the same payment method used in the purchase.`,
      trackRefund: `Track my refund`,
      backHome: `Back to home page`,
    },
    confirmCancelRefund: {
      title: `Your refund is in progress`,
      greeting: `Hi, {{userFirstName}}! How are you?`,
      processingMessage: `We received your refund request for {{productName}} and we are already processing it. The amount of {{currentPrice}} will be refunded within 24 business hours.`,
      changedMindTitle: `Changed your mind?`,
      changedMindDescription: `If you want to keep the product, you can cancel the refund here:`,
      keepPurchase: `Keep my purchase`,
      orderDetailsTitle: `Order details`,
      orderIdLabel: `ID:`,
      orderAmountLabel: `Amount:`,
      supportMessage: `If you have questions about the product, contact the producer support using the email below:`,
      orCountOn: `or count on`,
      caktoSupport: `Cakto support`,
      snackbar: {
        success: `Refund canceled successfully`,
        error: `Error canceling refund`,
      },
    },
    howRefundsWork: {
      title: `How does refund work?`,
      description: `Our policy guarantees 7 calendar days to request a refund for any purchase. Once the request is submitted, your refund is processed automatically within 24 hours — the seller is notified and has that window to reach out, but the refund does not depend on their approval. The full amount returns to the same payment method used in the purchase.`,
    },
    modalTrySupport: {
      title: `Need help with your purchase?`,
      descriptionLine1: `Many issues can be solved quickly with the producer.`,
      descriptionLine2: `If you prefer, contact support before proceeding with the refund:`,
      talkToSupport: `Talk to support`,
      continueRefund: `Continue with refund`,
    },
    modalRefundBlocked: {
      title: `This refund is handled by the producer`,
      descriptionLine1: `The producer is responsible for refunding this product.`,
      descriptionLine2: `Contact them at the e-mail below to request your refund.`,
      talkToSupport: `Contact the producer`,
    },
    modalRefundInsufficientBalance: {
      title: `Your refund can't be requested right now`,
      description: `There is no balance available to return the amount of this purchase, so your refund request was not opened.`,
      productSupport: `Contact the product support at the e-mail below:`,
      caktoSupportFallback: `If that doesn't solve it, contact Cakto support.`,
      caktoSupportOnly: `Contact Cakto support to find out how to proceed.`,
      talkToProductSupport: `Contact product support`,
      talkToCaktoSupport: `Contact Cakto support`,
      close: `Close`,
    },
    purchaseCard: {
      productImageAlt: `Product`,
      fields: {
        amount: `Amount:`,
        purchaseDate: `Purchase date:`,
        refundDeadline: `Refund request deadline:`,
        refundDeadlineShort: `Refund until:`,
        status: `Status:`,
        unknown: `Unknown`,
      },
      status: {
        processing: `Processing`,
        authorized: `Authorized`,
        paid: `Paid`,
        refunded: `Refunded`,
        waiting_payment: `Awaiting payment`,
        refused: `Declined`,
        chargedback: `Chargeback`,
        canceled: `Canceled`,
        in_protest: `In dispute`,
        partially_paid: `Partially paid`,
        refund_requested: `Refund in progress`,
        acquirer_error: `Refund not completed`,
        in_settlement: `Refund in progress`,
        expired: `Expired`,
      },
      refundFailed: {
        title: `We could not complete your refund`,
        description: `The seller, or one of their affiliates, does not have enough balance to return the amount. Please contact them directly at the email below:`,
      },
      refundInProgress: {
        title: `Refund in progress`,
        description: `The amount will be returned within 24 hours, to the same payment method used in the purchase.`,
      },
      refundSent: {
        title: `Refund sent to the payment method`,
        description: `This refund can no longer be canceled. We are waiting for the payment method to confirm it, and how long the amount takes to show up depends on your bank or card issuer.`,
      },
      refundInReview: {
        title: `Your refund is under review`,
        description: `The payment method did not confirm the refund and our team is looking into it. You do not need to request it again. If you want to reach the seller, use the email below:`,
      },
      requestRefund: `Request refund`,
      expiredRefund: `Refund expired`,
      refundBlocked: `Refund blocked`,
      cancelRefund: `Cancel refund`,
      snackbar: {
        notFound: `No refund request found`,
        expiredUpdating: `Refund request expired, we are updating the information`,
      },
    },
    renderPurchaseCards: {
      empty: `No purchases found!`,
    },
  },
  checkoutBuilder: {
    v1Mock: {
      fullName: 'Full name',
      fullNamePlaceholder: 'Enter your name',
      emailPlaceholder: 'Enter your email',
      confirmEmailPlaceholder: 'Confirm your email',
      phonePlaceholder: 'Enter your phone',
      documentPlaceholder: 'Enter it to issue your invoice',
      fullNameSample: 'Buyer name',
      email: 'Email',
      emailSample: 'email@email.com',
      confirmEmail: 'Confirm your email',
      phone: 'Phone',
      phoneSample: '(555) 555-5555',
      document: 'Tax ID',
      documentSample: '123-45-6789',
      documentHelp: 'We ask for your document to issue the invoice. Your data is encrypted and safe.',
      offer: 'Offer',
      installmentsLine: '{{count}}x of {{value}}',
      cashLine: '{{value}} upfront',
      paymentTitle: 'Payment method',
      cardNumber: 'Card number',
      cardNumberPlaceholder: '0000 0000 0000 0000',
      expiration: 'Expiration',
      expirationPlaceholder: 'MM/YY',
      cvv: 'CVV',
      cvvPlaceholder: '000',
      cardNumberSample: '5125 1456 5641 4010',
      expirationSample: '10/25',
      cvvSample: '123',
      expressPayWith: 'Pay with',
      expressDivider: 'OR',
      newBadge: 'NEW',
      pagaleveTab: 'PIX 4x interest-free',
      pagaleveTitle: 'Pay in Pix installments without a card',
      pagaleveDescription: 'With Pagaleve you can pay in Pix installments without a credit card or bank limit.',
      pagaleveHint: 'Your purchase is already pre-approved! To finish, just click Pay with Pix Installments',
      pagaleveToday: 'Today',
      pagaleveDays: '{{days}} days',
      installments: 'Installments',
      subscription: 'Subscription',
      boletoNotice: 'Bank slips can take up to 3 business days to clear after payment.',
      addBump: 'Add product!',
      removeBump: 'Remove product',
      summaryTitle: 'Order summary',
      couponPlaceholder: 'Discount code',
      applyCoupon: 'Apply coupon',
      removeCoupon: 'Remove coupon',
      invalidCoupon: 'Invalid coupon',
      couponApplied: 'Coupon applied ({{percent}}%)',
      singlePayment: 'One-time payment',
      total: 'Total',
      payNow: 'Pay now',
      payWith: 'Pay with {{method}}',
      generatePix: 'Generate PIX',
      securePurchase: 'Secure purchase',
      termsIntro: 'By proceeding, you agree to the',
      termsOfUse: 'Terms of use',
      termsOf: 'of',
      termsSeller: 'the seller',
      termsAnd: ', as well as the',
      terms: 'Terms',
      termsAndPolicies: 'and',
      policies: 'Policies',
      termsCakto: 'of Cakto.',
      processedBy: 'Processed by Cakto',
      morStatement: 'Cakto Commerce OÜ is the Merchant of Record and the entity responsible for this purchase.',
      registryCode: 'Registry code',
      country: 'Country',
      entityCountry: 'Estonia',
      contact: 'Contact',
      agreeWithTerms: 'By continuing, you agree to the',
      purchaseTerms: 'Purchase Terms',
      privacyPolicyJoiner: 'and',
      privacyPolicy: 'Privacy Policy',
      recaptchaNotice: 'This site is protected by Google reCAPTCHA',
      installmentWithInterest: '* Installment payment includes interest.',
    },
    paymentMethods: {
      pix: `Pix`,
      pix_auto: `Automatic Pix`,
      boleto: `Bank Slip`,
      credit_card: `Credit Card`,
      picpay: `PicPay`,
      applepay: `Apple Pay`,
      googlepay: `Google Pay`,
      openfinance_nubank: `Nubank`,
      paypal_wallet: `PayPal`,
      mercadopago_wallet: `Mercado Pago`,
      pagaleve: `Pix Installments`,
      threeDs: `3DS`,
      debit_card: `Debit Card`,
      oxxo: `OXXO`,
      spei: `SPEI`,
      pse: `PSE`,
      nequi: `Nequi`,
      safetypay: `SafetyPay`,
      rapipago: `Rapipago`,
      pagofacil: `Pago Fácil`,
    },
    payButton: {
      label: `Pay with`,
    },
    orderSummary: {
      title: `Order summary`,
      couponPlaceholder: `Discount code`,
      removeCoupon: `Remove coupon`,
      applyCoupon: `Apply coupon`,
      couponApplied: `Coupon applied`,
      total: `Total`,
      invalidCoupon: `Invalid coupon`,
    },
    orderBumps: {
      limitedOffer: `Limited offer`,
      limitedOffers: `Limited offers`,
      selected: `Selected`,
      subscription: `Subscription`,
      installments: `Installments`,
      addProduct: `Add product`,
    },
    productDescription: {
      connector: `or`,
      upfront: `upfront`,
    },
    productPurchase: {
      securePurchase: `Secure purchase`,
      needHelp: `Need help?`,
      sellerContact: `See seller contact`,
      total: `Total`,
      connector: `or`,
      termsConnector: `and`,
      processing: `Cakto is processing this payment for seller`,
      captcha: `This site is protected by Google's reCAPTCHA`,
      privacyPolicy: `Privacy policy`,
      termsOfService: `Terms of service`,
      installments: `* Installments may include additional fees`,
      purchaseTermsIntro: `By continuing, you agree to the`,
      purchaseTerms: `Purchase Terms`,
      currentRenewal: `Current renewal`,
      upfront: `upfront`,
    },
    paymentDetails: {
      cardNumber: `Card number`,
      expiration: `Expiration`,
      subscription: `Subscription`,
      installments: `Installments`,
      saveCard: `Save card details for future purchases`,
      security: `Your payment data is encrypted and processed securely.`,
    },
    pix: {
      instantRelease: `Instant release`,
      bankApp: `Use your banking app to complete the Pix payment`,
    },
    boleto: {
      message: `Bank slips may take up to 3 business days to clear after payment.`,
    },
    threeDs: {
      security: `Extra security with 3D Secure authentication`,
      fraud: `Protection against fraud in online transactions`,
      approval: `Faster and more reliable approval`,
    },
    preview: {
      yourDetails: `Your details`,
      fullName: `Full name`,
      buyerName: `Buyer name`,
      confirmEmail: `Confirm your email`,
      phone: `Phone`,
      payment: `Payment`,
      processingTooltip: `Send email to {{email}}`,
      processing: `Cakto is processing this payment for seller`,
      securePurchase: `100% secure purchase`,
      captcha: `This site is protected by Google's reCAPTCHA`,
      privacyPolicy: `Privacy policy`,
      termsOfService: `Terms of service`,
      termsConnector: `and`,
      installments: `* Installments may include additional fees`,
      purchaseTermsIntro: `By continuing, you agree to the`,
      purchaseTerms: `Purchase Terms`,
      phoneSample: `+1 (555) 555-5555`,
      phoneFlagAlt: `United States Flag`,
    },
    price: {
      singleInstallment: `1 x of {{value}}`,
    },
    recurrence: {
      renewal: `{{period}} renewal`,
      units: {
        day: `day`,
        week: `week`,
        month: `month`,
        bimonth: `bimonth`,
        quarter: `quarter`,
        semester: `semester`,
        year: `year`,
      },
      labels: {
        daily: `daily`,
        weekly: `weekly`,
        monthly: `monthly`,
        bimonthly: `bimonthly`,
        quarterly: `quarterly`,
        semiannual: `semiannual`,
        annual: `annual`,
      },
    },
  },
  contactPage: {
    pageTitle: {
      area: `Pages`,
      screen: `Contact`,
    },
    hero: {
      title: {
        where: `Where`,
        to: `to`,
        find: `find`,
        us: `us?`,
      },
    },
    form: {
      titleLine1: `Feel free to contact us.`,
      titleLine2: `We'll be glad to hear from you.`,
      name: `Name`,
      email: `Email`,
      subject: `Subject`,
      message: `Enter your message here.`,
      submit: `Submit now`,
    },
    map: {
      address: `Address`,
    },
  },
};

export default en;
